var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.829958 5.50634C0.405196 5.7289 0.422829 6.05492 0.868359 6.23204L2.18653 6.75358C2.63206 6.92952 3.30565 6.83352 3.68378 6.53807L9.40945 2.02281C9.78602 1.72619 9.82638 1.77007 9.49918 2.12038L4.97257 6.96518C4.64459 7.31471 4.74138 7.74261 5.18808 7.91541L5.34247 7.97576C5.78918 8.14817 6.51801 8.43892 6.96158 8.61917L8.42396 9.21517C8.86792 9.39542 9.23116 9.5451 9.23195 9.54785C9.23234 9.55059 9.2343 9.55882 9.23665 9.5596C9.239 9.56039 9.34362 9.18265 9.4694 8.72066L11.6982 0.527917C11.824 0.0655374 11.5799 -0.130778 11.1555 0.0917912L0.829958 5.50634Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44884 10.8685C4.42259 10.9465 5.35048 9.52484 5.35048 9.52484C5.61263 9.12437 5.46412 8.64671 5.02055 8.46568L4.0088 8.0511C3.56523 7.86968 3.35285 8.08245 3.53662 8.52602C3.53662 8.52641 4.47549 10.7885 4.44884 10.8685Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.31f7768416689f4c3567346c681de19b.svg";
export { ForwardRef as ReactComponent };